(function () {
  'use strict';

  // Mobile menu
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      nav.classList.toggle('is-open', !open);
    });
  }

  // Hero video: load the wide or tall cut depending on the screen
  var heroVideo = document.querySelector('[data-hero-video]');
  if (heroVideo) {
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var tall = window.matchMedia && window.matchMedia('(max-width: 720px)').matches;
    if (tall && heroVideo.dataset.posterTall) heroVideo.poster = heroVideo.dataset.posterTall;
    if (!reduceMotion) {
      heroVideo.muted = true;
      heroVideo.setAttribute('playsinline', '');
      heroVideo.src = tall ? heroVideo.dataset.srcTall : heroVideo.dataset.srcWide;
      var p = heroVideo.play();
      if (p && p.catch) p.catch(function () {});
    }
  }
  // Uploaded hero videos (video_tag) need playsinline for iOS
  document.querySelectorAll('.hero__media video').forEach(function (v) {
    v.muted = true;
    v.setAttribute('playsinline', '');
  });

  // Product gallery thumbnails
  var mainImage = document.querySelector('[data-main-image]');
  document.querySelectorAll('[data-thumb]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!mainImage) return;
      mainImage.removeAttribute('srcset');
      mainImage.src = btn.dataset.src;
      document.querySelectorAll('[data-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
    });
  });

  // Variant select: update price, image, button and URL
  var select = document.querySelector('[data-variant-select]');
  if (select) {
    select.addEventListener('change', function () {
      var opt = select.options[select.selectedIndex];
      var priceWrap = document.querySelector('[data-price-wrap] [data-price]');
      if (priceWrap) {
        var html = '<span class="price__now">' + opt.dataset.price + '</span>';
        if (opt.dataset.compare) html += '<s class="price__was">' + opt.dataset.compare + '</s>';
        priceWrap.innerHTML = html;
      }
      if (opt.dataset.image && mainImage) {
        mainImage.removeAttribute('srcset');
        mainImage.src = opt.dataset.image;
      }
      var addBtn = document.querySelector('[data-add-button]');
      if (addBtn) addBtn.disabled = opt.dataset.available !== 'true';
      var url = new URL(window.location.href);
      url.searchParams.set('variant', opt.value);
      window.history.replaceState({}, '', url.toString());
    });
  }

  // Collection sort
  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }
})();
